import flattenContestRounds from './flattenContestRounds';

export default (contest) => {
  return {
    ...contest,
    rounds: flattenContestRounds(contest),
  };
};
